import { createErrorFactory } from '@cadence-mq/core';

export const createJobWithSameIdExistsError = createErrorFactory({
  code: 'jobs.unique-id-constraint-violation',
  message: 'A job with the same id already exists',
});
